module.exports = __webpack_public_path__ + "media/images/sales/smakon/logo-5a72aeb439b1cbed28bb6c2b9490e311.svg";